import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as SitecoreLink, Text } from '@sitecore-content-sdk/nextjs';
const LinkListItem = (props)=>{
    let className = `item${props.index}`;
    className += (props.index + 1) % 2 == 0 ? ' even' : ' odd';
    if (props.index == 0) {
        className += ' first';
    }
    if (props.index + 1 == props.total) {
        className += ' last';
    }
    return /*#__PURE__*/ _jsx("li", {
        className: className,
        children: /*#__PURE__*/ _jsx("div", {
            className: "field-link",
            children: /*#__PURE__*/ _jsx(SitecoreLink, {
                field: props.field
            })
        })
    });
};
export const Default = (props)=>{
    const datasource = props.fields?.data?.datasource;
    const styles = `component link-list ${props?.params?.styles}`.trimEnd();
    const id = props.params.RenderingIdentifier;
    if (datasource) {
        const list = datasource.children.results.filter((element)=>element?.field?.link).map((element, key)=>/*#__PURE__*/ _jsx(LinkListItem, {
                index: key,
                total: datasource.children.results.length,
                field: element.field.link
            }, `${key}${element.field.link}`));
        return /*#__PURE__*/ _jsx("div", {
            className: styles,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "component-content",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        tag: "h3",
                        field: datasource?.field?.title
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        children: list
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("h3", {
                children: "Link List"
            })
        })
    });
};
